module.exports = __webpack_public_path__ + "static/img/wangguan.4b3bb50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hardware/wangguan.png
// module id = RUts
// module chunks = 1